/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-inline-styles */
/*
Author: Gilang Romadhanu Tartila
*/

import React, { useState, useEffect } from 'react';
import { View, TouchableOpacity } from 'react-native';
import SociollaText from '@components/sociolla/SociollaText';
import Colors from '@global/colors';
import Button from '@components/form/Button';
import ItemDetail from '@components/global/ItemDetail';
import TitleSubSection from '@components/global/TitleSubSection';
import Table from '@components/table/Table';
import Image from '@components/global/Image';
import * as Layout from '@components/screen/Layout';
import { isWeb, isMobileWeb } from '@global/screens';
import { parseDate, hasNoAccess } from '@global/helpers';

import useApi from '@/hooks/useApi';
import { MsB2b } from '@api/ms-b2b';

const tableStructure = {
  no_shelving: {
    head: 'Planogram Name',
    body: 'name',
  },
  url: {
    head: 'File Name',
    body: 'url',
  },
  icon: {
    head: 'View',
    body: 'icon',
    type: 'imageClick',
    style: { width: 25, height: 25, marginLeft: 12 },
  },
};

const PlanogramDetailScreen = (props) => {
  const [detailData, setDetailData] = useState({});

  const getPlanogramDetail = useApi(MsB2b.getPlanogramDetail);

  const getDetail = async (id) => {
    const response = await getPlanogramDetail.request(id);
    if (response?.data?.data && Object.keys(response.data.data).length) {
      const result = response.data.data;
      if (result && result.shelves && result.shelves.length) {
        result.shelves = result.shelves.map((item) => ({
          ...item,
          icon: require('@/assets/img/icons/attachment.png'),
        }));
      }
      setDetailData(result);
    } else {
      setDetailData({});
    }
  };

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      setDetailData({});
      if (props?.route?.params?.id) {
        getDetail(props.route.params.id);
      }
    }
    return () => {
      mounted = false;
    };
  }, [props]);

  return (
    <Layout.Container>
      {isWeb ? (
        <Layout.Back
          title="Planogram"
          onCallback={() => props.navigation.navigate('PlanogramScreen')}
        />
      ) : (
        false
      )}
      <Layout.Wrapper rounded>
        {getPlanogramDetail && getPlanogramDetail.loading ? (
          <Layout.Loader />
        ) : detailData && Object.keys(detailData).length ? (
          <Layout.ScrollViewRefresher
            onCallback={() => getDetail(props?.route?.params?.id)}>
            {isWeb ? (
              <Layout.Title
                title={
                  detailData.account_group && detailData.account_group.code
                    ? detailData.account_group.code
                    : '-'
                }
                style={{
                  paddingTop: 20,
                  paddingHorizontal: 25,
                }}>
                {hasNoAccess([
                  'salesman',
                  'sales_supervisor',
                  'branch_head',
                  'finance_supervisor',
                  'regional_manager',
                  'regional_support',
                  'key_account_manager',
                  'group_key_account_manager',
                  'national_key_account_manager',
                  'vice_president_finance',
                  'budget_controller',
                  'finance_head',
                  'tax_support',
                  'billing_supervisor',
                  'general_manager_marketing',
                  'marketing_support',
                  'collector',
                ]) ? (
                  <Button
                    type="primary"
                    rounded={true}
                    buttonStyle={{ width: 100 }}
                    title={
                      <SociollaText
                        type="bold"
                        style={{ fontSize: 14, color: Colors.white }}>
                        Edit
                      </SociollaText>
                    }
                    onPress={() =>
                      props.navigation.navigate('PlanogramFormScreen', {
                        titleScreen:
                          detailData.account_group.code &&
                          detailData.account_group.code
                            ? detailData.account_group.code
                            : '-',
                        name:
                          detailData.account_group.code &&
                          detailData.account_group.code
                            ? detailData.account_group.code
                            : '-',
                        id: detailData._id,
                      })
                    }
                  />
                ) : (
                  false
                )}
              </Layout.Title>
            ) : (
              false
            )}
            <View
              style={{
                width: isWeb ? 400 : '100%',
                paddingBottom: 15,
                paddingHorizontal: isWeb ? 25 : 15,
              }}>
              <ItemDetail
                name="Account Group"
                value={
                  detailData.account_group && detailData.account_group.code
                    ? detailData.account_group.code
                    : '-'
                }
              />
              <ItemDetail
                name="Last Update"
                value={
                  detailData.updated_at ? parseDate(detailData.updated_at) : '-'
                }
              />
            </View>
            <TitleSubSection title="PLANOGRAM" />
            <View style={{ width: '100%', paddingHorizontal: 20 }}>
              {isWeb ? (
                <Table
                  structures={tableStructure}
                  data={
                    detailData.shelves && detailData.shelves.length
                      ? detailData.shelves
                      : []
                  }
                  withFetch={false}
                  hasNoHide={true}
                  showFilter={false}
                  noTopSection={true}
                  showPagination={false}
                  withoutShadow={true}
                  totalData={
                    (detailData.shelves && detailData.shelves.length) || 0
                  }
                  limit={
                    (detailData.shelves && detailData.shelves.length) || 10
                  }
                />
              ) : detailData.shelves && detailData.shelves.length ? (
                detailData.shelves.map((item, idx) => (
                  <View
                    key={idx}
                    style={{ display: 'flex', flexDirection: 'row' }}>
                    <View style={{ width: '85%' }}>
                      <ItemDetail
                        key={idx}
                        name={`Planogram ${item?.position}`}
                        value={item?.url ? item?.url : '-'}
                      />
                    </View>
                    <View
                      style={{
                        width: '15%',
                        justifyContent: 'center',
                        alignItems: 'center',
                        display: 'flex',
                        borderBottomColor: Colors.grey0,
                        borderBottomWidth: 1,
                      }}>
                      <TouchableOpacity
                        onPress={() => {
                          if (isMobileWeb) {
                            window.open(item?.url ? item?.url : '', '_blank');
                          }
                        }}>
                        <View
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}>
                          <Image
                            style={{
                              width: 24,
                              height: 24,
                            }}
                            width={24}
                            compressWidth={24}
                            height={24}
                            source={require('@/assets/img/icons/attachment.png')}
                          />
                        </View>
                      </TouchableOpacity>
                    </View>
                  </View>
                ))
              ) : (
                false
              )}
            </View>
          </Layout.ScrollViewRefresher>
        ) : (
          <SociollaText style={{ fontSize: 13, color: Colors.grey1 }}>
            Planogram not found.
          </SociollaText>
        )}
      </Layout.Wrapper>
    </Layout.Container>
  );
};

export default PlanogramDetailScreen;
